import { httpGet, httpPost, httpPut, httpPatch, httpDelete, setTokenProvider } from './http/httpClient';
import type { ApiResponse } from './http/types';

// Lightweight wrapper around the existing http client. Exported so services

export const apiClient = {
  get: httpGet,
  post: httpPost,
  put: httpPut,
  patch: httpPatch,
  delete: httpDelete,
  setTokenProvider,
};

export async function unwrapApiResponse<T>(p: Promise<ApiResponse<T>> | (() => Promise<ApiResponse<T>>)): Promise<T> {
  const res = typeof p === 'function' ? await p() : await p;
  if (res.success) {
    // non-null assertion since success=true implies data present
    return res.data as T;
  }
  const err = new Error(res.error?.message || 'API request failed');
  // attach details for callers to inspect
  const errWithDetails = err as Error & { details?: unknown };
  errWithDetails.details = res.error || { message: err.message };
  throw err;
}

export type { ApiResponse } from './http/types';

export default apiClient;
